export default __webpack_public_path__ + "static/media/img_services06.13a91c6e.png";